import { render, staticRenderFns } from "./LessonDetailView.vue?vue&type=template&id=4bb3764e&scoped=true"
import script from "./LessonDetailView.vue?vue&type=script&lang=js"
export * from "./LessonDetailView.vue?vue&type=script&lang=js"
import style0 from "./LessonDetailView.vue?vue&type=style&index=0&id=4bb3764e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb3764e",
  null
  
)

export default component.exports